export enum DownloadAppPlatform {
  Ios = 'ios',
  Android = 'android',
}
